var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5796_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6255 10.8801C23.5235 10.5165 23.325 10.1873 23.051 9.92756C22.7692 9.65982 22.4238 9.46829 22.0475 9.37106C20.639 8.99981 14.996 8.99981 14.996 8.99981C12.6435 8.97305 10.2915 9.09077 7.95346 9.35231C7.57711 9.45672 7.23239 9.65253 6.94996 9.92231C6.67246 10.1893 6.47146 10.5186 6.36646 10.8793C6.11423 12.2381 5.99168 13.6178 6.00046 14.9998C5.99146 16.3806 6.11371 17.7598 6.36646 19.1203C6.46921 19.4796 6.66946 19.8073 6.94771 20.0721C7.22596 20.3368 7.57246 20.5281 7.95346 20.6293C9.38071 20.9998 14.996 20.9998 14.996 20.9998C17.3515 21.0266 19.7064 20.9089 22.0475 20.6473C22.4238 20.5501 22.7692 20.3586 23.051 20.0908C23.3285 19.8261 23.5257 19.4968 23.6247 19.1383C23.8835 17.78 24.0094 16.3998 24.0005 15.0171C24.0199 13.6285 23.8942 12.2417 23.6255 10.8793V10.8801ZM13.202 17.5678V12.4326L17.897 15.0006L13.202 17.5678Z",
    fill: "#2C333A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5796_3305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6e02100b6d7c658d3fb507592601cd8b.svg";
export { ForwardRef as ReactComponent };